import apiClient from './client'
import type { ApiResponse } from '@portal/types'
import type { UserWithPermissions } from '@portal/types'

interface UsersListResult {
  data: UserWithPermissions[]
  total: number
  page: number
  limit: number
}

interface CreateUserResult {
  user: UserWithPermissions
  activationUrl: string
}

export const usersApi = {
  list: (opts?: { page?: number; limit?: number; search?: string }) => {
    const params = new URLSearchParams()
    if (opts?.page) params.set('page', String(opts.page))
    if (opts?.limit) params.set('limit', String(opts.limit))
    if (opts?.search) params.set('search', opts.search)
    return apiClient.get(`/api/users?${params}`) as unknown as Promise<ApiResponse<UsersListResult>>
  },

  create: (data: {
    email: string
    name: string
    phone?: string
    role: string
    permissions?: { module: string; granted: boolean }[]
    dailyPaymentLimitRupees?: number | null
    transactionLimitRupees?: number | null
  }) =>
    apiClient.post('/api/users', data) as unknown as Promise<ApiResponse<CreateUserResult>>,

  get: (id: string) =>
    apiClient.get(`/api/users/${id}`) as unknown as Promise<ApiResponse<UserWithPermissions>>,

  update: (id: string, data: { name?: string; phone?: string; role?: string; isActive?: boolean; dailyPaymentLimitRupees?: number | null; transactionLimitRupees?: number | null }) =>
    apiClient.put(`/api/users/${id}`, data) as unknown as Promise<ApiResponse<UserWithPermissions>>,

  updatePermissions: (id: string, permissions: { module: string; granted: boolean }[]) =>
    apiClient.put(`/api/users/${id}/permissions`, { permissions }) as unknown as Promise<
      ApiResponse<UserWithPermissions>
    >,

  delete: (id: string) =>
    apiClient.delete(`/api/users/${id}`) as unknown as Promise<ApiResponse<void>>,

  resendActivation: (id: string) =>
    apiClient.post(`/api/users/${id}/resend-activation`) as unknown as Promise<
      ApiResponse<{ activationUrl: string }>
    >,

  resetPassword: (id: string) =>
    apiClient.post(`/api/users/${id}/reset-password`) as unknown as Promise<
      ApiResponse<{ activationUrl: string }>
    >,
}
